import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import { Chip } from '@mui/material';

import useStyles from './styles';

const ChipCounter = ({ label, data }) => {
    const { classes } = useStyles();
    const counter = useMemo(() => (Array.isArray(data) ? data.length : data), [data]);

    if (!counter) {
        return null;
    }

    return (
        <Chip
            className={classes.exactMatch}
            variant="outlined"
            label={
                <span>
                    {label}&nbsp;<span className={classes.exactMatchCounter}>{counter}</span>
                </span>
            }
        />
    );
};

ChipCounter.propTypes = {
    label: PropTypes.node,
    data: PropTypes.oneOf([PropTypes.array, PropTypes.number])
};

export default ChipCounter;
